var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"wrap":"","pa-3":""}},[_c('v-flex',{attrs:{"sm12":"","pr-2":""}},[_c('v-text-field',{attrs:{"clearable":"","label":_vm.$t('Admin.Search'),"append-icon":"mdi-magnify"},model:{value:(_vm.adminFilterSearch),callback:function ($$v) {_vm.adminFilterSearch=$$v},expression:"adminFilterSearch"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }